import React, { useEffect } from 'react';

export const PwaLoader = () => {
  useEffect(() => {
    // Because of routing on develop/live, we need to prefix the asset dir with
    // '/portal' in these environments

    const url = window.location.href;
    const isLocal = url.includes('localhost');
    const isElevate = url.includes('elevatedirect');

    const prefix = isLocal ? '' : '/portal';

    const manifest = document.createElement('link');
    manifest.rel = 'manifest';

    if (isLocal) {
      manifest.href = `${prefix}/myn-local-manifest.json`;
    } else if (isElevate) {
      manifest.href = `${prefix}/elevate-manifest.json`;
    } else {
      manifest.href = `${prefix}/myn-manifest.json`;
    }

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(manifest);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register(`${prefix}/sw.js`);
    }

    if (isElevate) {
      document.body.classList.add('blue-theme');
    }
  }, []);

  return <></>;
};
